module.exports = __webpack_public_path__ + "media/images/logo-white-ff6602cc404ca0d4571473da9ef91b74.svg";